import React from 'react';
import { useAuth } from '../../contexts/authContext';

/**
 * =========================================================================
 * SUPERVISOR REPORTS PAGE
 * =========================================================================
 * 
 * Reports page for supervisor users.
 * Currently a placeholder - functionality to be implemented.
 * 
 * Access Control:
 * - Requires 'view_reports' permission
 * =========================================================================
 */
const Reports = () => {
  const { user } = useAuth();

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-7xl mx-auto py-6 sm:px-6 lg:px-8">
        {/* Page Header */}
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-gray-900">Reports</h1>
          <p className="mt-2 text-gray-600">
            View and analyze team performance and statistics
          </p>
        </div>

        {/* Coming Soon Card */}
        <div className="bg-white overflow-hidden shadow rounded-lg">
          <div className="px-4 py-5 sm:p-6">
            <div className="text-center py-12">
              <svg 
                className="w-16 h-16 text-gray-400 mx-auto mb-4" 
                fill="none" 
                stroke="currentColor" 
                viewBox="0 0 24 24"
              >
                <path 
                  strokeLinecap="round" 
                  strokeLinejoin="round" 
                  strokeWidth="2" 
                  d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" 
                />
              </svg>
              <h2 className="text-xl font-semibold text-gray-900 mb-2">
                Reports Coming Soon
              </h2>
              <p className="text-gray-600 mb-6">
                We're working on comprehensive reporting features for supervisors.
              </p>
              
              {/* Feature Preview */}
              <div className="max-w-md mx-auto">
                <h3 className="text-sm font-medium text-gray-900 mb-3">
                  Planned Features:
                </h3>
                <ul className="text-sm text-gray-600 space-y-1">
                  <li>• Team performance analytics</li>
                  <li>• Member activity reports</li>
                  <li>• Progress tracking</li>
                  <li>• Export capabilities</li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* User Info Debug (remove in production) */}
        {process.env.NODE_ENV === 'development' && (
          <div className="mt-8 bg-yellow-50 border border-yellow-200 rounded-lg p-4">
            <h3 className="text-sm font-medium text-yellow-800 mb-2">
              Debug Info (Development Only)
            </h3>
            <p className="text-xs text-yellow-700">
              User: {user?.name} | Permissions: {user?.permissions?.join(', ') || 'None'}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default Reports; 